// TODO: We need to translate these

function appLauncherItemsPayload() {
    const menuItems = [
        {
            name: 'Trailblazer Community',
            url: 'https://trailhead.salesforce.com/auth/tbidlogin?state=/trailblazer-community/feed',
            image: '/images/app-launcher/trailblazer-community.svg',
            position: 1,
        },
        {
            name: 'Trailhead',
            url: 'https://trailhead.salesforce.com/auth/tbidlogin',
            image: '/images/app-launcher/trailhead.svg',
            position: 0,
        },
        {
            name: 'IdeaExchange',
            url: 'https://ideas.salesforce.com/',
            image: '/images/app-launcher/ideaexchange.svg',
            position: 3,
        },
        {
            name: 'Partner Community',
            url: 'https://partners.salesforce.com/',
            image: '/images/app-launcher/partnercommunity.svg',
            position: 2,
        },
        {
            name: 'Salesforce Help',
            url: 'https://help.salesforce.com/',
            image: '/images/app-launcher/help.svg',
            position: 5,
        },
        {
            name: 'Events',
            url: 'https://trailhead.salesforce.com/community/events',
            image: '/images/app-launcher/events.svg',
            position: 4,
        },
    ];

    return menuItems.sort((prev, current) => (prev.position > current.position ? 1 : -1));
}

function addIdAppLauncheritem() {
    const menuItems = appLauncherItemsPayload();

    return menuItems.map((item, index) => {
        index++;
        return {
            ...item,
            id: index,
        };
    });
}
export const appLauncherItems = addIdAppLauncheritem();
